export default __webpack_public_path__ + "static/media/monstera.9ec7803b.gif";